import { SpraypaintBase } from 'spraypaint';

const ApplicationRecord = SpraypaintBase.extend({
  static: {
    baseUrl: '',
    apiNamespace: '/api/v1',
  }
})

export default ApplicationRecord;
